import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useQuery } from '@percent/utility'
import { StaticLinks } from './StaticLinks'
import { StaticLinksContainerProps } from './StaticLinks.types'
import { DeleteStaticLinkModal } from './deleteStaticLinkModal/DeleteStaticLinkModal'

export function StaticLinksContainer({ partnerId }: StaticLinksContainerProps) {
  const navigate = useNavigate()
  const { adminService, validationSubmissionsService } = useServices()
  const [selectedStaticLink, setSelectedStaticLink] = useState<{ id: string; slug: string } | null>(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)

  const {
    data: staticLinks,
    isLoading,
    errorMessage,
    refetch
  } = useQuery(['static-links', partnerId], adminService.queries.getStaticLinks, {
    partnerId
  })

  const { data: configurations } = useQuery(
    ['validation-submission-configurations', partnerId],
    validationSubmissionsService.getValidationSubmissionConfigurations,
    { partnerId, pageSize: 100 }
  )

  const configurationNames = useMemo(() => {
    if (!configurations) return {}

    return configurations.reduce<Record<string, string>>((acc, config) => {
      acc[config.id] = config.name || config.id

      return acc
    }, {})
  }, [configurations])

  const handleEditClick = (staticLink: { id: string; slug: string }) => {
    navigate(`/partners/${partnerId}/static-links/${staticLink.id}/edit`)
  }

  const handleDeleteClick = (staticLink: { id: string; slug: string }) => {
    setSelectedStaticLink(staticLink)
    setIsDeleteModalOpen(true)
  }

  const handleDeleteModalClose = () => {
    setIsDeleteModalOpen(false)
    setSelectedStaticLink(null)
  }

  return (
    <>
      <StaticLinks
        staticLinks={staticLinks ?? []}
        isLoading={isLoading}
        errorMessage={errorMessage}
        partnerId={partnerId}
        configurationNames={configurationNames}
        onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
      />
      {selectedStaticLink && (
        <DeleteStaticLinkModal
          isOpen={isDeleteModalOpen}
          onClose={handleDeleteModalClose}
          staticLinkId={selectedStaticLink.id}
          staticLinkSlug={selectedStaticLink.slug}
          onSuccess={refetch}
        />
      )}
    </>
  )
}
